// General imports
import "./components";
import "./initializers";
import "./template";
import "./vue";

const version_deploy = "09/04/2026 16:48'";
// console.log("Version deployed: " + version_deploy);
